import type { ApiError } from '../shared/schemas';

/** Error text from an API response; proxies may answer 429/502 with HTML instead of the JSON envelope. */
export async function apiErrorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const body = await response.json() as Partial<ApiError>;
    if (typeof body.error?.message === 'string') return body.error.message;
  } catch { /* non-JSON body */ }
  if (response.status === 429) return 'Слишком много запросов. Повторите позже.';
  return `${fallback} (HTTP ${response.status})`;
}
